import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { UserRequest } from '../../service/user.request';

export const fetchUserProfile = createAsyncThunk(
	'user/fetchProfile',
	async (_, { rejectWithValue }) => {
		try {
			const req = new UserRequest();
			const res = await req.getMe();
			return res.data?.data;
		} catch (error: any) {
			console.log('error', error?.response?.data);
			return rejectWithValue(error?.response?.data);
		}
	}
);

interface UserState {
	id: string;
	username: string;
	telegramId: string;
	accessToken: string;
	avatar?: string;
	walletAddress: string;
	isLoading: boolean;
	firstName: string;
	lastName: string;
	isPremium: boolean;
}

const initialState = {
	id: '',
	username: '',
	telegramId: '',
	accessToken: '',
	walletAddress: '',
	isLoading: true,
	firstName: '',
	lastName: '',
	isPremium: false,
} as UserState;

const userSlice = createSlice({
	name: 'user',
	initialState,
	reducers: {
		updateUser(state, action: PayloadAction<UserState>) {
			state = {
				...state,
				...action.payload,
			};
			return state;
		},
		setLoading(state, action: PayloadAction<boolean>) {
			state.isLoading = action.payload;
		},
	},
	extraReducers: (builder) => {
		builder.addCase(fetchUserProfile.fulfilled, (state, action) => {
			if (action.payload) {
				return { ...state, ...action.payload };
			}
		});
	},
});

export const { updateUser, setLoading } = userSlice.actions;
export default userSlice.reducer;
